import styled from 'styled-components';
import { spaceMixin, token } from '@zillow/constellation';

import { MUIBreakpointLg } from '../../constants';

export const StyledSectionRight = styled.div`
  .SectionRight-linkContainer {
    list-style-type: none;

    .SectionRight-link {
      display: none;
      padding: 0 0 0 ${spaceMixin('lg')};
      white-space: nowrap;
      text-align: center;
      font-size: 16px;

      .Link {
        color: ${token('colors.gray600')};
        text-decoration: none;
        font-weight: 400;
      }

      .Link:hover {
        color: ${token('colors.blue400')};
        font-weight: 600;
      }

      .BrandLink.Link::before {
        content: attr(title);
        display: block;
        font-weight: 600;
        height: 0;
        overflow: hidden;
        visibility: hidden;
      }

      @media screen and (min-width: ${MUIBreakpointLg}) {
        display: block;
      }
    }

    &.Link::before {
      content: attr(title);
      display: block;
      font-weight: 600;
      height: 0;
      overflow: hidden;
      visibility: hidden;
    }

    .SectionRight-notificationCenter {
      padding: 0 0 0 ${spaceMixin('lg')};
    }
  }
`;

export const StyledSubText = styled.div`
  font-size: 12px;
  color: ${token('colors.textDark')};
  font-weight: normal;
`;
